import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification, Modal, Select, Spin, Result } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ticketsActions from "../../redux/ticket/actions";
import { epochToNormalDate } from "../../utils/utility";
import warningIcon from "../../images/alert-sign.png";
import { t } from "i18next";
import "../FavoriteDestinationSettings/index.css";
const { Option } = Select;

const RefundSchedulesModal = ({
  setNewPlaceNumber,
  newPlaceNumber,
  newForDate,
  newKursId,
  newPriceId,
  setShowSchedulesModal,
  setSelectedBox,
  setNewForDate,
  setNewKursId,
  setNewPriceId,
  showSchedulesModal,
  selectedBox,
}) => {
  const dispatch = useDispatch();

  const { editTicket } = ticketsActions;
  const { companies, token } = useSelector((state) => state.mainReducer);
  const { singleTicketInfo } = useSelector((state) => state.ticketReducer);
  const { refundSchedulesLoading } = useSelector(
    (state) => state.schedulesReducer
  );

  const { refundTicketSchedules } = useSelector(
    (state) => state.schedulesReducer
  );

  useEffect(() => {
    if (singleTicketInfo.length > 0) {
      setNewPlaceNumber(singleTicketInfo[0]?.place);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleTicketInfo]);

  const newTicketObject = {
    placeNumber: newPlaceNumber,
    ticketNumber: singleTicketInfo[0]?.ticketNumber,
    forDate: newForDate,
    kursId: newKursId,
    priceId: newPriceId,
  };

  const reconfirmTicket = () => {
    if (
      newKursId &&
      newPriceId &&
      newForDate &&
      newPlaceNumber &&
      singleTicketInfo[0]?.ticketNumber
    ) {
      dispatch(editTicket(token, companies[0]?.id, newTicketObject));
      setShowSchedulesModal(false);
    } else {
      notification.error({
        message: t("pleaseSelectSchedule"),
        placement: "top",
      });
    }
  };

  return (
    <Modal
      width="400px"
      styles={{
        content: { padding: "0", margin: "0", borderRadius: "10px" },
      }}
      title=""
      onCancel={() => {
        setShowSchedulesModal(false);
        setSelectedBox(null);

        setNewPlaceNumber(singleTicketInfo[0]?.place);
        setNewForDate(null);
        setNewKursId(null);
        setNewPriceId(null);
      }}
      footer={null}
      centered
      open={showSchedulesModal}
    >
      {!refundSchedulesLoading ? (
        <div className="new-course-container">
          <div className="new-course-header">
            {singleTicketInfo?.map((ticket) => {
              return (
                <p
                  key={ticket.ticketNumber}
                  style={{ fontWeight: "600", fontSize: "23px" }}
                >
                  {ticket.fromName} - {ticket.toName}
                </p>
              );
            })}
            <p style={{ fontSize: "16px" }}>
              {t("pleaseSelect")}{" "}
              <span style={{ fontWeight: "bold" }}>{t("dateAndHour")}</span> и
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {t("place")?.toLowerCase()}{" "}
              </span>{" "}
              {t("inBusAndChooseNewDetails")}
            </p>
          </div>

          <div className="new-course-route-container">
            {refundTicketSchedules.map((schedule) =>
              schedule.scheduleStart ===
              singleTicketInfo[0]?.startTime ? null : (
                <div
                  key={schedule.kursId}
                  className={`new-course-route-box ${
                    selectedBox === schedule.kursId ? "new-course-selected" : ""
                  }`}
                  onClick={() => {
                    setSelectedBox(schedule.kursId);
                    setNewForDate(schedule.scheduleStart);
                    setNewKursId(schedule.kursId);
                    setNewPriceId(
                      schedule.price.find(
                        (price) => price.name === singleTicketInfo[0]?.typeName
                      )?.id
                    );
                  }}
                >
                  <div className="new-course-date">
                    {epochToNormalDate(schedule.scheduleStart).split(" ")[0]}
                  </div>
                  <div className="new-course-time">
                    {epochToNormalDate(schedule.scheduleStart).split(" ")[1]}
                  </div>

                  {selectedBox === schedule.kursId && (
                    <div style={{ flexBasis: "100%", marginTop: "10px" }}>
                      <Select
                        className="ticket-seat-select"
                        value={newPlaceNumber}
                        style={{ width: "100%", height: "50px" }}
                        onChange={(value) => {
                          setNewPlaceNumber(value);
                        }}
                      >
                        {schedule?.schemePlace?.statusPlaces
                          ?.filter((seat) => seat.taken === false)
                          ?.map((seat) => (
                            <Option key={seat.number} value={seat.number}>
                              {t("place")} {seat.number}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  )}
                </div>
              )
            )}
            {refundTicketSchedules.length === 0 && (
              <Result
                icon={
                  <img
                    className="empty-favorite-destination-image"
                    src={warningIcon}
                    alt="noSchedule"
                  />
                }
                title={t("resultsNotFound")}
              />
            )}

            <div className="new-course-button-container">
              <button className="new-course-button" onClick={reconfirmTicket}>
                {t("revalidateTheTicket")}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            height: "300px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      )}
    </Modal>
  );
};

export default RefundSchedulesModal;
